/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import {
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiPopover,
  EuiText,
  EuiTitle,
} from '@elastic/eui'

import { connectedClustersURL } from '@modules/ccm-user-lib/urls'
import { CuiRouterLink } from '@modules/cui/RouterButton'
import { useToggle } from '@modules/utils/hooks/useToggle'

import messages from '../messages'

import type { FC } from 'react'

const CCMPanelTitle: FC = () => {
  const [isPopoverOpen, togglePopover, setPopoverOpen] = useToggle()

  const { formatMessage } = useIntl()

  return (
    <EuiFlexGroup gutterSize='xs' alignItems='center' responsive={false}>
      <EuiFlexItem grow={0}>
        <CuiRouterLink
          to={connectedClustersURL()}
          color='text'
          data-test-id='portal-ess-title-link'
          className='cloud-portal-tile-title'
        >
          <EuiTitle size='xs'>
            <h2>{formatMessage(messages.ccmClustersTileTitle)}</h2>
          </EuiTitle>
        </CuiRouterLink>
      </EuiFlexItem>
      <EuiFlexItem grow={0}>
        <EuiPopover
          button={
            <EuiButtonIcon
              iconType='question'
              onClick={togglePopover}
              aria-label={formatMessage({
                id: 'project.portalPanel.title.info',
                defaultMessage: 'more information about projects',
              })}
            />
          }
          anchorPosition='upCenter'
          isOpen={isPopoverOpen}
          closePopover={() => setPopoverOpen(false)}
        >
          <EuiText css={{ width: 300 }} size='s'>
            <p>
              {formatMessage(messages.titlePopover, {
                link: (content) => (
                  // TODO: https://github.com/elastic/cloud/issues/142673 replace with actual URL
                  <EuiLink href='https://www.elastic.co' target='_blank'>
                    {content}
                  </EuiLink>
                ),
              })}
            </p>
          </EuiText>
        </EuiPopover>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
}

export default CCMPanelTitle
